import axios from 'axios';
import { normalizeJSONAPIResponse } from 'utils/modelUtils';

export const updateSound = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await axios.post('/api/v3/sounds', formData);
  return normalizeJSONAPIResponse(response.data);
};
